import moment from 'moment';

export const updatedAtColumn = {
  Header: 'Updated at',
  accessor: 'updatedAt',
  Cell: ({ value }: any) => {
    const updatedAt = moment(value);
    return value && updatedAt.isValid()
      ? updatedAt.format('DD MMM YYYY, h:mm A')
      : '—';
  },
};
